module.exports = __webpack_public_path__ + "img/1092931053.884958f7.jpg";